import React, {useEffect, useState} from 'react';
import {NotificationManager} from 'react-notifications';
import connection from '../../../connection';
import moment from 'moment';
import {getLeaguePlayerADetails, getOffersForLeague, getOffersForTournament} from '../../../services/enrollments';
import {Col, Container, Row, Button} from "react-bootstrap";
import {useAuth} from "../../../contexts/authContext";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import Input from '../../../components/Input/Input';
import InputSelect from '../../../components/InputSelect/InputSelect';
import InputRadio from '../../../components/InputRadio/InputRadio';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";
import {isFilled} from "../../../utils";

// CSS Files
import './styles.css';

const PlayerOneRegistration = (props) => {
   const [state, setState] = useState({
      original_details: {},
      id: '',
      name: '',
      email: '',
      gender: '',
      birthyear: '',
      federated_fpp: false,
      fpp_licence: '',
      site_url: '',
      offer_id: '',
      offer_size_id: '',
      phone_number: '',
      social_media: false
   });
   const [offers, setOffers] = useState([]);
   const auth = useAuth();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
            await getOffers();

            if (props.formData.is_replication) {
               if (props.formData.replication_is_league) {
                  await getLeaguePlayerDetails();
               } else {
                  await getTournamentPlayerDetails();
               }
            } else {
               if (auth.user) {
                  if (typeof props.formData.user_registration === 'undefined') {
                     preFillFields();
                  } else {
                     setState(props.formData.user_registration);
                  }
               }
            }
         }
      )();
   }, []);

   const preFillFields = () => {
      let user_details = auth.user;

      let federated = user_details.fpp_licence != null && user_details.fpp_licence != '';
      let social_media = !!user_details.social_media;

      setState(state => ({
         ...state,
         original_details: user_details,
         id: user_details.id,
         name: user_details.name === null ? '' : user_details.name,
         email: user_details.email,
         gender: user_details.gender === null ? '' : user_details.gender,
         birthyear: user_details.birthyear ? '****' : '',
         federated_fpp: federated,
         fpp_licence: user_details.fpp_licence === null ? '' : user_details.fpp_licence,
         site_url: user_details.site_url === '' ? '' : "***",
         phone_number: user_details.phone_number === null ? '' : user_details.phone_number.replace(/\w(?=\w{3})/g, "*"),
         offer_id: user_details.latest_offer_id === null ? '' : user_details.latest_offer_id,
         offer_size_id: user_details.latest_offer_size_id === null ? '' : user_details.latest_offer_size_id,
         social_media: social_media,
      }));
   }

   const getSizesForOffer = (offer_id) => {
      let sizes = [];

      offers.map((offer) => {
         if (offer.id == offer_id) {
            if (offer.sizes[0].size_name !== "GENERIC") {
               sizes = offer.sizes;
            }
         }
      });
      
      return sizes;
   }

   const getLeaguePlayerDetails = async () => {
      try {
         let user_details = await getLeaguePlayerADetails(props.formData.enrollment_id);

         let federated = user_details.fpp_licence != null && user_details.fpp_licence != '';
         let social_media = !!user_details.social_media;

         setState(state => ({
            ...state,
            original_details: user_details,
            id: user_details.id,
            email: user_details.email === null ? '' : user_details.email,
            name: user_details.name === null ? '' : user_details.name,
            phone_number: user_details.phone_number === null ? '' : user_details.phone_number,
            fpp_licence: user_details.fpp_licence === null ? '' : user_details.fpp_licence,
            site_url: user_details.site_url === '' ? '' : "***",
            gender: user_details.gender === null ? '' : user_details.gender,
            birthyear: user_details.birthyear ? '****' : '',
            federated_fpp: federated,
            offer_id: user_details.offer_id === null ? '' : user_details.offer_id,
            offer_size_id: user_details.offer_size_id === null ? '' : user_details.offer_size_id,
            social_media: social_media,
            welcome_pack_needed: user_details.welcome_pack_needed
         }));
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   const getTournamentPlayerDetails = async () => {
      try {
         let user_details = await connection.post(`v1/tournament_registrations/${props.formData.registration_id}/player_a_details.json`);

         let federated = user_details.fpp_licence != null && user_details.fpp_licence != '';
         let social_media = !!user_details.social_media;

         setState(state => ({
            ...state,
            original_details: user_details,
            id: user_details.id,
            email: user_details.email === null ? '' : user_details.email,
            name: user_details.name === null ? '' : user_details.name,
            phone_number: user_details.phone_number === null ? '' : user_details.phone_number,
            fpp_licence: user_details.fpp_licence === null ? '' : user_details.fpp_licence,
            site_url: user_details.site_url === '' ? '' : "***",
            gender: user_details.gender === null ? '' : user_details.gender,
            birthyear: user_details.birthyear === null ? '' : "****",
            federated_fpp: federated,
            offer_id: user_details.offer_id === null ? '' : user_details.offer_id,
            offer_size_id: user_details.offer_size_id === null ? '' : user_details.offer_size_id,
            social_media: social_media,
            welcome_pack_needed: user_details.welcome_pack_needed
         }));
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   const getOffers = async () => {
      try {
         if (props.formData.isLeague) {
            let offers = await getOffersForLeague(props.formData.id);

            setOffers(offers);
         } else {
            let offers = await getOffersForTournament(props.formData.id);
            setOffers(offers);
         }
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   const handleChange = (e) => {
      const { name, value } = e.target;

      if (name === "social_media") {
         if (!value) {
            setState(state => ({ ...state, site_url: '' }));
         }
      }
      if (name === "federated_fpp") {
         if (!value) {
            setState(state => ({ ...state, fpp_licence: '' }));
         }
      }
      setState(state => ({ ...state, [name]: value }));
   }

   const verifyPlayerData = () => {
      let isAcceptable = true;

      if (state.email === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.email_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      } else {
         if (!/^[^@]+@[^@]+\.[^@]+$/.test(state.email)) {
            isAcceptable = false;
            NotificationManager.error(t("registration_page.errors.email_invalid"), t("common.error"), 4000);
            return isAcceptable;
         }
      }

      if (state.name === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.name_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      }

      if (state.gender === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.gender_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      }

      if (state.birthyear === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.birthyear_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      } else {
         if (!/^[0-9]+$/.test(state.birthyear) && !isFilled(state.original_details.birthyear)) {
            isAcceptable = false;
            NotificationManager.error(t("registration_page.errors.birthyear_invalid_spaces"), t("common.error"), 4000);
            return isAcceptable;
         }

         if (!(parseInt(state.birthyear) > moment().year() - 70 && parseInt(state.birthyear) < moment().year() - 12) && !isFilled(state.original_details.birthyear)) {
            isAcceptable = false;
            NotificationManager.error(t("common.form.errors.invalid_year"), t("common.error"), 4000);
            return isAcceptable;
         }
      }

      if (state.phone_number === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.phone_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      } else {
         if (!isFilled(state.original_details.phone_number)) {
            if (/^351/.test(state.phone_number)) {
               isAcceptable = false;
               NotificationManager.error(t("registration_page.errors.phone_country_prefix"), t("common.error"), 4000);
               return isAcceptable;
            }

            if (state.phone_number.length < 9) {
               isAcceptable = false;
               NotificationManager.error(t("common.form.errors.invalid_phone_number"), t("common.error"), 4000);
               return isAcceptable;
            }

            if (!/^[0-9]+$/.test(state.phone_number)) {
               isAcceptable = false;
               NotificationManager.error(t("common.form.errors.special_characters"), t("common.error"), 4000);
               return isAcceptable;
            }
         }
      }

      if (props.formData.welcomepack_needed && state.offer_id === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.offer_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      }

      if (props.formData.welcomepack_needed && state.offer_size_id === '') {
         isAcceptable = false;
         NotificationManager.error(t("registration_page.errors.offer_size_mandatory"), t("common.error"), 4000);
         return isAcceptable;
      }

      if (props.formData.fpp_licence_needed) {
         if (state.federated_fpp) {
            if (state.fpp_licence === '' || isNaN(state.fpp_licence) || /\s/.test(state.fpp_licence)) {
               isAcceptable = false;
               NotificationManager.error(t("registration_page.errors.license_mandatory"), t("common.error"), 4000);
               return isAcceptable;
            } else {
               if (/\s/.test(state.fpp_licence)) {
                  isAcceptable = false;
                  NotificationManager.error(t("registration_page.errors.license_invalid"), t("common.error"), 4000);
                  return isAcceptable;
               }
            }
         }
      }

      if (state.social_media) {
         if (state.site_url === '') {
            isAcceptable = false;
            NotificationManager.error(t("registration_page.errors.facebook_mandatory"), t("common.error"), 4000);
            return isAcceptable;
         } else {
            if (!/^[A-Za-z0-9.]*$/.test(state.site_url) && !isFilled(state.original_details.site_url)) {
               isAcceptable = false;
               NotificationManager.error(t("registration_page.errors.facebook_invalid"), t("common.error"), 4000);
               return isAcceptable;
            }
         }
      }

      return isAcceptable
   }

   const submit = (data) => {
      if (verifyPlayerData()) {
         props.onSubmit(data);
      }
   }

   const options = [];

   for (let i = moment().subtract(70, 'years').format('YYYY'); i < moment().subtract(11, 'years').format('YYYY'); i++) {
      options.push(i)
   }

   let sizes = getSizesForOffer(state.offer_id)
   let showNoPartnerButton = !props.formData.isLeague && props.formData.allow_singles;

   if (state.offer_id !== '') {
      let offer_found = false;
      offers.map((offer) => {
         if (offer.id == state.offer_id) {
            offer_found = true;
         }
      })
      if (!offer_found) {
         setState(state => ({ ...state, offer_id: '' }));
      }
   }

   return (
      <div>
         <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton />

         <Container className={"desktop"}>
            <Row>
               <Col className={"pb-3"} xs={12} sm={12}>
                  <BulletHeader text={t("registration_page.player1_data")}/>
                  <p>{t("registration_page.check_player1_data")}</p>
               </Col>
            </Row>
            <Row>
               <Col xs={12} sm={12}>
                  <Input handleChange={handleChange} name="email" id="playerOneEmail" inputType="email" text={t("common.form.labels.email")} inputTextValue={state.email} disabled={auth.user !== null || props.formData.is_replication}/>
                  <Input handleChange={handleChange} name="name" id="playerOneName" inputType="text" text={t("common.form.labels.name")} inputTextValue={state.name} disabled={props.formData.is_replication || isFilled(state.original_details.name)}/>
                  <InputSelect labelClasses="label-style" inputType="text" text={t("common.form.labels.gender")}>
                     <select onChange={handleChange} value={state.gender !== '' ? state.gender : 'DEFAULT'} name="gender" className="input-background" disabled={isFilled(state.original_details.gender)}>
                        <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                        <option value="Masculino">{t("common.form.options.male")}</option>
                        <option value="Feminino">{t("common.form.options.female")}</option>
                     </select>
                  </InputSelect>
                  <Input id="BirthYear" name="birthyear" text={t("common.form.labels.birth_year")} inputType="text" handleChange={handleChange} inputTextValue={state.birthyear} disabled={isFilled(state.original_details.birthyear)}/>
                  <Input handleChange={handleChange} name="phone_number" labelClasses="label-style" id="playerOnePhoneNumber" inputType="text" text={t("common.form.labels.phone_number")} inputTextValue={state.phone_number} disabled={isFilled(state.original_details.phone_number)}/>
                  {props.formData.welcomepack_needed && <InputSelect text={t("common.form.labels.offer")}>
                     <select onChange={handleChange} value={state.offer_id !== '' ? state.offer_id : 'DEFAULT'} name="offer_id" style={{width: '100%', marginTop: 8}} className="input-background">
                        <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                        {offers && offers.map((offer, index) => {
                           return <option key={index} value={offer.id}>{offer.offer_name}</option>
                        })}
                     </select>
                  </InputSelect>}
                  {state.offer_id !== '' && sizes.length !== 0 && props.formData.welcomepack_needed && <InputSelect text={t("common.form.labels.offer_size")}>
                     <select onChange={handleChange} value={state.offer_size_id !== '' ? state.offer_size_id : 'DEFAULT'} name="offer_size_id" style={{width: '100%', marginTop: 8}} className="input-background">
                        <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                        {sizes.map((size, index) => {
                           return <option key={index} value={size.id}>{size.size_name}</option>
                        })}
                     </select>
                  </InputSelect>}
                  {props.formData.fpp_licence_needed && <InputRadio handleChange={handleChange} name="federated_fpp" text={t("common.form.labels.is_federated")} firstRadioText={t("common.yes")} secondRadioText={t("common.no")} checked={(state.federated_fpp || state.fpp_licence != '')} showInfoButton/>}
                  {(state.federated_fpp || state.fpp_licence != '') && <Input handleChange={handleChange} name="fpp_licence" id="fppLicence" inputType="number" text={t("common.form.labels.federative_license")} inputTextValue={state.fpp_licence}/>}
                     <InputRadio handleChange={handleChange} name="social_media" isColumn={true} text={t("common.form.labels.social_networks")} firstRadioText={t("registration_page.social_networks_yes")} secondRadioText={t("registration_page.social_networks_no")} checked={(state.social_media || state.site_url != '')} disabled={isFilled(state.original_details.social_media)}/>
                  {(state.social_media || state.site_url != '') && <div style={{marginBottom: 20, marginTop: 20}} className="div-background-row align-row">
                     <Input handleChange={handleChange} text="facebook.com/" name="site_url" inputType="text" id="facebookUserName" inputTextValue={state.site_url} disabled={isFilled(state.original_details.site_url)}/>
                  </div>}
               </Col>
            </Row>
            <Row>
               <Col xs={{span: 12, order: 1}} sm={{span: 6, offset: showNoPartnerButton ? 0 : 6, order: 12}} md={{offset: showNoPartnerButton ? 0 : 7, order: 12}}>
                  <Button onClick={() => {
                     submit({user_registration: state})
                  }} className={"mt-2 mb-4 w-100"} variant="primary">{t("registration_page.next")}</Button>
               </Col>
               {showNoPartnerButton &&
                  <Col xs={{span: 12, order: 12}} sm={{span: 6, order: 1}} md={{order: 1}}>
                     <Button onClick={() => {
                        submit({user_registration: state, single_enrollment: true})
                     }} className={"mt-2 mb-4 w-100"} variant="secondary">{t("registration_page.no_partner")}</Button>
                  </Col>
               }
            </Row>
         </Container>
      </div>
   );
}

export default PlayerOneRegistration;
